import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '@environment';
import { ReplyTemplatesTree } from '@sb-tools/typescript/models/reply-templates-tree.model';
import { ReplyTemplate } from '@sb-tools/typescript/models/reply-template.model';
import { AllReplyTemplatesModel } from '@sb-tools/typescript/models/all-reply-templates-model.model';

@Injectable({
    providedIn: 'root',
})
export class ReplyTemplateDataService {
    constructor(private httpClient: HttpClient) {}

    getAll(): Observable<ReplyTemplate[]> {
        return this.httpClient.get<ReplyTemplate[]>(environment.apiInboxUrl + 'replyTemplates');
    }

    getAllReplyTemplates(): Observable<AllReplyTemplatesModel> {
        return this.httpClient.get<AllReplyTemplatesModel>(environment.apiInboxUrl + 'allReplyTemplates');
    }

    getReplyTemplatesTree(): Observable<ReplyTemplatesTree> {
        return this.httpClient.get<ReplyTemplatesTree>(environment.apiInboxUrl + 'replyTemplatesTree/');
    }
}
